import { render } from "./SubGrupoCreate.vue?vue&type=template&id=52321b8a&scoped=true"
import script from "./SubGrupoCreate.vue?vue&type=script&lang=js"
export * from "./SubGrupoCreate.vue?vue&type=script&lang=js"

import "./SubGrupoCreate.vue?vue&type=style&index=0&id=52321b8a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52321b8a"]])

export default __exports__